import { Injectable, inject } from '@angular/core';
import { DirtyCheckPlugin, QueryEntity } from '@datorama/akita';
import { DisclosureApplication } from '../../models/disclosure-type.model';
import { DisclosureApplicationState, DisclosureApplicationStore } from './disclosure-application.store';

@Injectable({ providedIn: 'root' })
export class DisclosureApplicationQuery extends QueryEntity<DisclosureApplicationState, DisclosureApplication> {
  protected store: DisclosureApplicationStore;

  dirtyChecker = new DirtyCheckPlugin(this);

  constructor() {
    const store = inject(DisclosureApplicationStore);

    super(store);

    this.store = store;
  }
}
